import React from 'react'
import { useSelector } from 'react-redux'
import ChatList from '@pages/common/chat-list'

// 강사: 자기 강좌에 지정된 문의만 조회
const TeacherChatPage = () => {
  const account = useSelector(state => state.accountReducer)
  return (
    <ChatList query={{ lectureYn: 'Y', userId: account?.user?.id }} />
  )
}

export default TeacherChatPage
